export const fallbackLng = ["en","es"];
export const supportedLngs = ["en","es"];
export const languageSelectionAllowed = false;